export default __webpack_public_path__ + "static/forum_logo-fe7d9f72d3b7686cca6e3f3c1b240452.gif";